import React from 'react';

import LogoLoader from 'components/Loader/LogoLoader';
import { StatusMascot } from 'components/Mascot';
import APIErrorMascot from 'components/Mascot/APIErrorMascot';
import { useFetchBillingDetails } from 'hooks/accountBilling/useFetchBillingDetails';

import FreeTrial from '../FreeTrial';
import Subscription from '../Subscription';

const BillingPlan: React.FC<unknown> = () => {
  const { data, status, error } = useFetchBillingDetails();

  if (status === 'loading') return <LogoLoader />;

  if (status === 'error') return <StatusMascot type="error" description={(error as any)?.message} />;
  if (!data?.payload) return <APIErrorMascot />;

  return (
    <React.Fragment>{data?.payload?.plan_name === 'Free Trial' ? <FreeTrial /> : <Subscription />}</React.Fragment>
  );
};

export default BillingPlan;
